"use client";

import { useBrand } from "./brand-provider";

function DefaultMark({ className = "h-9 w-9 shrink-0" }: { className?: string }) {
  return (
    <svg viewBox="0 0 36 36" className={className} aria-hidden="true">
      <rect width="36" height="36" rx="10" fill="#0f766e" />
      <path
        d="M8 18c5-8 15-8 20 0"
        fill="none"
        stroke="#99f6e4"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M11 18c3.5-5 10.5-5 14 0"
        fill="none"
        stroke="#ecfdf5"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <circle cx="18" cy="22.5" r="2.1" fill="#5eead4" />
    </svg>
  );
}

const markClass: Record<"default" | "auth" | "sidebar", string> = {
  default: "h-9 w-9 shrink-0 object-contain",
  auth: "h-16 w-16 shrink-0 object-contain sm:h-20 sm:w-20",
  sidebar: "h-11 w-11 shrink-0 object-contain",
};

export function Logo({
  className = "",
  variant = "default",
}: {
  className?: string;
  variant?: "default" | "auth" | "sidebar";
}) {
  const { name, logoUrl } = useBrand();
  if (variant === "auth") {
    return (
      <span className={`flex flex-col items-center text-center ${className}`}>
        {logoUrl ? (
          <img src={logoUrl} alt="" className={markClass.auth} />
        ) : (
          <DefaultMark className="h-16 w-16 shrink-0 sm:h-20 sm:w-20" />
        )}
        <span className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl">{name}</span>
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {logoUrl ? (
        <img src={logoUrl} alt="" className={markClass[variant]} />
      ) : (
        <DefaultMark className={variant === "sidebar" ? "h-11 w-11 shrink-0" : undefined} />
      )}
      <span className="text-lg font-semibold tracking-tight">{name}</span>
    </span>
  );
}
